"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Authentication_1 = __importDefault(require("@lwt-common/authentication/build/Authentication"));
var APP_ID_PLATFORM_UI = "ul";
var APP_ID_FOUNDATION = "fdn";
var TOKEN_KEY_NAME = "lwaToken";
var SESSION_CHECK_KEY_NAME = "lwaSessionCheck";
var SESSION_CHECK_KEY_MAX_AGE = 365 * 24 * 60 * 60 * 1000; // 365 days in milliseconds.
var getTokenCookieName = function (lwDomain) {
    return "".concat(TOKEN_KEY_NAME, "@@").concat(lwDomain);
};
var getSessionCheckCookieName = function (lwDomain) {
    return "".concat(SESSION_CHECK_KEY_NAME, "@@").concat(lwDomain);
};
var buildUrl = function (lwDomain, prefix) {
    return "https://".concat(prefix, ".").concat(lwDomain);
};
var buildProductLaunchUrl = function (domain, connection, luParamValue) {
    var url;
    if (connection.platformClient && connection.clientId === null) {
        var platformClientConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(platformClientConnection.appId);
    }
    else if (connection.platformClient) {
        var platformClientConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(platformClientConnection.appId, "&ac=").concat(platformClientConnection.clientId);
    }
    else if (connection.clientId != null) {
        var clientConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(clientConnection.appId, "&c=").concat(clientConnection.clientId, "&m=").concat(clientConnection.memberId);
    }
    else if (connection.userId != null) {
        var userConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(userConnection.appId, "&u=").concat(userConnection.userId);
    }
    else {
        url = "".concat(domain, "/product/launch?a=").concat(connection.appId);
    }
    if (luParamValue) {
        url = "".concat(url, "&lu=").concat(luParamValue);
    }
    return url;
};
var isPlatformUiAppId = function (appId) {
    return appId === APP_ID_PLATFORM_UI;
};
var isPlatformOrFoundationApp = function (appId) {
    return appId === APP_ID_PLATFORM_UI || appId === APP_ID_FOUNDATION;
};
var isLwolfDomain = function (lwDomain) {
    return window.location.hostname.includes(lwDomain);
};
var getStoredToken = function (lwDomain, appId) {
    var _a, _b;
    var token = (_a = sessionStorage.getItem(TOKEN_KEY_NAME)) !== null && _a !== void 0 ? _a : undefined;
    if (!token) {
        if (isLwolfDomain(lwDomain)) {
            token = getTokenFromCookie(lwDomain);
        }
        else {
            token = (_b = localStorage.getItem(TOKEN_KEY_NAME)) !== null && _b !== void 0 ? _b : undefined;
        }
        if (token) {
            storeToken(lwDomain, token, appId);
        }
    }
    return token;
};
var storeToken = function (lwDomain, token, appId) {
    var _a, _b, _c;
    if (token) {
        var parsedToken = Authentication_1.default.parseToken(token);
        var sessionCheckExpires = getSessionCheckExpires();
        // If the current application uses connections (not clients) from the LWA, set the token in session storage.
        var appsClaim = (_b = (_a = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLwtClaim()) === null || _a === void 0 ? void 0 : _a.getAppsClaim()) !== null && _b !== void 0 ? _b : {};
        var appsClaimRecord = appsClaim;
        if (!!appsClaimRecord[appId !== null && appId !== void 0 ? appId : '']) {
            sessionStorage.setItem(TOKEN_KEY_NAME, token);
        }
        if (isLwolfDomain(lwDomain)) {
            var tokenExpirationTime = (_c = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getExpirationTime()) !== null && _c !== void 0 ? _c : 0;
            var tokenExpires = new Date(tokenExpirationTime * 1000).toUTCString();
            document.cookie = "".concat(getTokenCookieName(lwDomain), "=").concat(token, ";Domain=.").concat(lwDomain, ";Secure;SameSite=Strict;Expires=").concat(tokenExpires, ";Path=/");
            document.cookie = "".concat(getSessionCheckCookieName(lwDomain), "=true;Domain=.").concat(lwDomain, ";Secure;SameSite=Strict;Expires=").concat(sessionCheckExpires, ";Path=/");
        }
        else {
            localStorage.setItem(TOKEN_KEY_NAME, token);
        }
    }
    else {
        sessionStorage.removeItem(TOKEN_KEY_NAME);
        if (isLwolfDomain(lwDomain)) {
            document.cookie = "".concat(getTokenCookieName(lwDomain), "=;Domain=.").concat(lwDomain, ";Expires=Thu, 01 Jan 1970 00:00:00 UTC;Path=/");
            document.cookie = "".concat(getSessionCheckCookieName(lwDomain), "=;Domain=.").concat(lwDomain, ";Expires=Thu, 01 Jan 1970 00:00:00 UTC;Path=/");
        }
        localStorage.removeItem(TOKEN_KEY_NAME);
        // We have left this in to clear unneeded data from local-storage for users already having sessions open in the browser.
        // We can remove this code later.
        localStorage.removeItem(SESSION_CHECK_KEY_NAME);
        localStorage.removeItem("lwaSessionCheckExpires");
    }
};
var getSessionCheckExpires = function () {
    return new Date(Date.now() + SESSION_CHECK_KEY_MAX_AGE).toUTCString();
};
var getTokenFromCookie = function (lwDomain) {
    var _a;
    var tokenCookie = (_a = document.cookie.split("; ")
        .find(function (row) { return row.startsWith("".concat(getTokenCookieName(lwDomain), "=")); })) === null || _a === void 0 ? void 0 : _a.split("=")[1];
    return tokenCookie;
};
var isTokenExpired = function (token) {
    var _a, _b;
    var tokenExpirationTime = (_b = (_a = Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getExpirationTime()) !== null && _b !== void 0 ? _b : 0;
    return tokenExpirationTime * 1000 < Date.now();
};
var getCompareFunction = function (field, options) {
    if (options === void 0) { options = {}; }
    return function (a, b) {
        var aV = a[field];
        var bV = b[field];
        if (typeof aV !== typeof bV) {
            throw 'Type mismatch when doing comparison.';
        }
        var ignoreCase = options.ignoreCase;
        if (typeof aV === 'string' && typeof bV === 'string') {
            var string1 = aV;
            var string2 = bV;
            if (ignoreCase) {
                string1 = string1.toLowerCase();
                string2 = string2.toLowerCase();
            }
            return string1.localeCompare(string2);
        }
        if (aV === bV) {
            return 0;
        }
        else {
            return aV < bV ? -1 : 1;
        }
    };
};
var makeFetchCall = function (url, token, additionalHeaders) {
    return fetch("".concat(url), {
        headers: __assign({ 'Authorization': "Bearer ".concat(token) }, (additionalHeaders ? additionalHeaders : {}))
    });
};
var getJsonResponseFromFetch = function (url, token, appId, tryRelaunch) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, makeFetchCall(url, token)];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    if (response.status === 401) {
                        if (!isPlatformUiAppId(appId)) {
                            tryRelaunch();
                        }
                    }
                    else {
                        throw new Error('Invalid response from platform API');
                    }
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
var PlatformService = /** @class */ (function () {
    function PlatformService(lwDomain, platformUrlOverride, token, appId, lwaOnly, includeOriginInRedirects, enablePopups, beforeSignOutCallback, luParamSupplier) {
        this.cachedClients = {};
        this.lwDomain = lwDomain;
        this.platformUrlOverride = platformUrlOverride;
        this.token = token;
        this.appId = appId;
        this.lwaOnly = lwaOnly;
        this.includeOriginInRedirects = includeOriginInRedirects;
        this.beforeSignOutCallback = beforeSignOutCallback;
        this.luParamSupplier = luParamSupplier;
        this.cachedClients = {};
        this.enablePopups = enablePopups;
    }
    PlatformService.initialize = function (_a) {
        var _b, _c, _d;
        var lwDomain = _a.lwDomain, platformUrlOverride = _a.platformUrlOverride, token = _a.token, appId = _a.appId, platformClientId = _a.platformClientId, forceEndLwaSession = _a.forceEndLwaSession, beforeSignOutCallback = _a.beforeSignOutCallback, luParamSupplier = _a.luParamSupplier, _e = _a.lwaOnly, lwaOnly = _e === void 0 ? false : _e, _f = _a.includeOriginInRedirects, includeOriginInRedirects = _f === void 0 ? false : _f, _g = _a.enablePopups, enablePopups = _g === void 0 ? false : _g;
        return __awaiter(this, void 0, void 0, function () {
            var doLwaSessionCheck, platformService, authenticationApiUrl, sessionStatusResponse, isAuthenticated, connectionToValidate, appData, userCanAccess;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (!lwDomain) {
                            throw Error('lwDomain is required.');
                        }
                        if (forceEndLwaSession) {
                            if (lwaOnly) {
                                throw Error('forceEndLwaSession cannot be true for lwaOnly mode.');
                            }
                            token = undefined;
                            storeToken(lwDomain, token, appId);
                        }
                        if (token) {
                            // If a token is passed in, save it to our storage chain.
                            storeToken(lwDomain, token, appId);
                            doLwaSessionCheck = true;
                        }
                        else {
                            // If a token is NOT passed in, try reading it from the storage chain.
                            token = getStoredToken(lwDomain, appId);
                            if (isLwolfDomain(lwDomain)) {
                                // IF the token we got was from the cookie, we use the cookie to get the session-check variable as well.
                                doLwaSessionCheck = ((_b = document.cookie
                                    .split("; ")
                                    .find(function (row) { return row.startsWith("".concat(getSessionCheckCookieName(lwDomain), "=")); })) === null || _b === void 0 ? void 0 : _b.split("=")[1]) !== undefined;
                            }
                            else {
                                doLwaSessionCheck = !!token;
                            }
                        }
                        platformService = new PlatformService(lwDomain, platformUrlOverride, token, appId, lwaOnly, includeOriginInRedirects, enablePopups, beforeSignOutCallback, luParamSupplier);
                        doLwaSessionCheck = doLwaSessionCheck || lwaOnly;
                        if (!(doLwaSessionCheck && !isPlatformUiAppId(appId))) return [3 /*break*/, 8];
                        if (!(!token || isTokenExpired(token))) return [3 /*break*/, 1];
                        platformService.tryRelaunch();
                        return [3 /*break*/, 3];
                    case 1:
                        authenticationApiUrl = platformService.getAuthenticationApiUrl();
                        return [4 /*yield*/, makeFetchCall("".concat(authenticationApiUrl, "/v1/check-session"), token)];
                    case 2:
                        sessionStatusResponse = _h.sent();
                        isAuthenticated = sessionStatusResponse.ok || sessionStatusResponse.status !== 403;
                        if (!isAuthenticated) {
                            platformService.tryRelaunch();
                        }
                        _h.label = 3;
                    case 3:
                        connectionToValidate = undefined;
                        if (!platformClientId) return [3 /*break*/, 4];
                        connectionToValidate = {
                            appId: appId,
                            platformClient: true,
                            clientId: platformClientId
                        };
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, platformService.getAppData()];
                    case 5:
                        appData = (_c = (_h.sent())) === null || _c === void 0 ? void 0 : _c.find(function (appData) { return appData.id === appId; });
                        // Otherwise, if it is a promotional app, we validate it as such.
                        if ((_d = appData === null || appData === void 0 ? void 0 : appData.config.promotion) === null || _d === void 0 ? void 0 : _d.url) {
                            connectionToValidate = {
                                name: '',
                                appId: appId,
                                pseudoPromotionalConnection: true
                            };
                            // Otherwise, if it is an app that always only uses the personal client, we validate it as such.
                        }
                        else if ((appData === null || appData === void 0 ? void 0 : appData.config.hidden) || (appData === null || appData === void 0 ? void 0 : appData.config.collapseItems)) {
                            connectionToValidate = {
                                appId: appId,
                                platformClient: true
                            };
                        }
                        _h.label = 6;
                    case 6:
                        if (!connectionToValidate) return [3 /*break*/, 8];
                        return [4 /*yield*/, platformService.userCanAccess(connectionToValidate)];
                    case 7:
                        userCanAccess = _h.sent();
                        if (!userCanAccess) {
                            platformService.tryRelaunch();
                        }
                        _h.label = 8;
                    case 8: return [4 /*yield*/, platformService.getAppData()];
                    case 9:
                        _h.sent();
                        return [2 /*return*/, platformService];
                }
            });
        });
    };
    PlatformService.prototype.getPlatformUrl = function () {
        var _a;
        return (_a = this.platformUrlOverride) !== null && _a !== void 0 ? _a : buildUrl(this.lwDomain, "platform");
    };
    PlatformService.prototype.getAuthenticationApiUrl = function () {
        return buildUrl(this.lwDomain, "authentication.api");
    };
    PlatformService.prototype.getPlatformApiUrl = function () {
        return buildUrl(this.lwDomain, "platform.api");
    };
    PlatformService.prototype.getEcommerceUrl = function () {
        return buildUrl(this.lwDomain, "ecommerce");
    };
    PlatformService.prototype.tryRelaunch = function (forceLogout) {
        if (forceLogout === void 0) { forceLogout = false; }
        storeToken(this.lwDomain, undefined, this.appId);
        if (this.beforeSignOutCallback) {
            this.beforeSignOutCallback();
        }
        var url;
        if (forceLogout) {
            url = "".concat(this.getPlatformUrl(), "/logout");
        }
        else if (this.appId && !isPlatformUiAppId(this.appId)) {
            var userUrlEncoded = encodeURIComponent(this.includeOriginInRedirects ? window.location.href : (window.location.pathname + window.location.search));
            url = "".concat(this.getPlatformUrl(), "/product/launch?a=").concat(this.appId, "&r=").concat(userUrlEncoded);
            if (this.luParamSupplier) {
                var luParamValue = this.luParamSupplier();
                if (luParamValue) {
                    url = "".concat(url, "&lu=").concat(luParamValue);
                }
            }
        }
        else {
            url = "".concat(this.getPlatformUrl());
        }
        window.location.assign(url);
    };
    PlatformService.prototype.getAuthenticatedIdPs = function (useCache) {
        var _this = this;
        if (useCache === void 0) { useCache = true; }
        var token = this.validateAndGetToken();
        if (!token) {
            return Promise.resolve([]);
        }
        if (useCache && this.cachedAuthenticatedIdPs !== undefined) {
            return Promise.resolve(__spreadArray([], this.cachedAuthenticatedIdPs, true));
        }
        return makeFetchCall("".concat(this.getAuthenticationApiUrl(), "/v1/authenticated-identity-providers"), token)
            .then(function (response) {
            if (!response.ok) {
                if (response.status === 401) {
                    if (!isPlatformUiAppId(_this.appId)) {
                        _this.tryRelaunch();
                        return [];
                    }
                    else {
                        return [];
                    }
                }
                else {
                    throw new Error('Invalid response from Authentication API');
                }
            }
            else {
                return response.json().then(function (responseJson) {
                    _this.cachedAuthenticatedIdPs = __spreadArray([], responseJson, true).map(function (idP) { return idP.id; });
                    return _this.cachedAuthenticatedIdPs;
                });
            }
        }).catch(function (err) {
            throw err;
        });
    };
    PlatformService.prototype.getAppData = function (useCache) {
        var _this = this;
        if (useCache === void 0) { useCache = true; }
        var token = this.validateAndGetToken();
        if (!token) {
            return Promise.resolve([]);
        }
        if (useCache && this.cachedAppData !== undefined) {
            return Promise.resolve(__spreadArray([], this.cachedAppData, true));
        }
        return makeFetchCall("".concat(this.getPlatformApiUrl(), "/v1/unified-login-configs"), token)
            .then(function (response) {
            if (!response.ok) {
                if (response.status === 401) {
                    if (!isPlatformUiAppId(_this.appId)) {
                        _this.tryRelaunch();
                    }
                    else {
                        return [];
                    }
                }
                else {
                    throw new Error('Invalid response from platform API');
                }
            }
            else {
                return response.json().then(function (responseJson) {
                    var _a;
                    _this.cachedAppData = __spreadArray([], responseJson, true);
                    var currentAppConfig = (_a = _this.cachedAppData.find(function (config) { return config.id === _this.appId; })) === null || _a === void 0 ? void 0 : _a.config;
                    _this.appName = currentAppConfig === null || currentAppConfig === void 0 ? void 0 : currentAppConfig.name;
                    return responseJson;
                });
            }
        }).catch(function (err) {
            throw err;
        });
    };
    PlatformService.prototype.getLwaClients = function (useCache) {
        var _this = this;
        var _a, _b;
        if (useCache === void 0) { useCache = true; }
        var token = this.validateAndGetToken();
        if (!token) {
            return Promise.resolve([]);
        }
        if (useCache && this.cachedLwaClients !== undefined) {
            return Promise.resolve(this.cachedLwaClients);
        }
        var userId = (_b = (_a = Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getUserId();
        return makeFetchCall("".concat(this.getAuthenticationApiUrl(), "/v1/users/").concat(userId, "/clients"), token)
            .then(function (response) {
            if (!response.ok) {
                if (response.status === 401) {
                    if (!isPlatformUiAppId(_this.appId)) {
                        _this.tryRelaunch();
                    }
                    else {
                        return [];
                    }
                }
                else {
                    throw new Error('Invalid response from authentication API');
                }
            }
            else {
                return response.json().then(function (responseJson) {
                    _this.cachedLwaClients = __spreadArray([], responseJson, true);
                    return responseJson;
                });
            }
        }).catch(function (err) {
            throw err;
        });
    };
    /**
     * @deprecated since version 3.12.0
     *
     * This function is deprecated and will be removed at some point in the future. Use the {@link PlatformService#getClientsInToken} function instead.
     */
    PlatformService.prototype.getClients = function () {
        return this.getClientsInToken();
    };
    PlatformService.prototype.getClientsInToken = function () {
        var _a, _b, _c;
        var token = this.validateAndGetToken();
        if (!token) {
            return Promise.resolve([]);
        }
        var clients = (_c = (_b = (_a = Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getClients()) !== null && _c !== void 0 ? _c : [];
        return Promise.resolve(clients);
    };
    PlatformService.prototype.getClientsSummary = function (useCache) {
        var _this = this;
        if (useCache === void 0) { useCache = true; }
        var doGetClientsSummary = function () { return __awaiter(_this, void 0, void 0, function () {
            var token, getPlatformClientSummary, clients, lwaClients, _i, lwaClients_1, lwaClient, response, responseJson, platformClient, clientsSummary;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        getPlatformClientSummary = function (clientId) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, makeFetchCall("".concat(this.getPlatformApiUrl(), "/v1/clients/").concat(clientId, "/summary"), token)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); };
                        clients = [];
                        if (!(useCache && Object.keys(this.cachedClients).length > 0)) return [3 /*break*/, 1];
                        (_a = Object.keys(this.cachedClients)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                            clients.push(_this.cachedClients[key]);
                        });
                        return [3 /*break*/, 8];
                    case 1: return [4 /*yield*/, this.getLwaClients(useCache)];
                    case 2:
                        lwaClients = _b.sent();
                        _i = 0, lwaClients_1 = lwaClients;
                        _b.label = 3;
                    case 3:
                        if (!(_i < lwaClients_1.length)) return [3 /*break*/, 8];
                        lwaClient = lwaClients_1[_i];
                        if (!token) {
                            token = this.validateAndGetToken();
                        }
                        return [4 /*yield*/, getPlatformClientSummary(lwaClient.clientId)];
                    case 4:
                        response = _b.sent();
                        if (!!response.ok) return [3 /*break*/, 5];
                        if (response.status === 401) {
                            if (!isPlatformUiAppId(this.appId)) {
                                this.tryRelaunch();
                                return [2 /*return*/, Promise.resolve([])];
                            }
                            else {
                                return [2 /*return*/, Promise.resolve([])];
                            }
                        }
                        else {
                            return [2 /*return*/, Promise.reject(new Error('Invalid response from platform API'))];
                        }
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, response.json()];
                    case 6:
                        responseJson = _b.sent();
                        platformClient = responseJson;
                        clients.push(platformClient);
                        _b.label = 7;
                    case 7:
                        _i++;
                        return [3 /*break*/, 3];
                    case 8:
                        clientsSummary = clients.map(function (c) {
                            var clientSummary = {
                                id: c.id,
                                name: c.name,
                                type: c.type,
                                externalSystemId: c.externalSystemId,
                                identityProviderId: c.identityProviderId
                            };
                            return clientSummary;
                        });
                        return [2 /*return*/, Promise.resolve(clientsSummary)];
                }
            });
        }); };
        return doGetClientsSummary();
    };
    PlatformService.prototype.getClientsAsConnections = function (useCache) {
        var _this = this;
        if (useCache === void 0) { useCache = true; }
        var token;
        var getPlatformClientSummary = function (clientId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, makeFetchCall("".concat(this.getPlatformApiUrl(), "/v1/clients/").concat(clientId, "/summary"), token)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        var mapClients = function () { return __awaiter(_this, void 0, void 0, function () {
            var clients, connections, clientsJustFetched, _i, clients_1, client, platformClient, response, responseJson, _loop_1, this_1, _a, _b, application, twConnections, twNonUserConnections, twUserConnection, userTypeClient, userTypeClientExternalSystems_1, removeTwUserConnection, _loop_2, _c, twNonUserConnections_1, twNonUserConnection, state_1, getClientType, twBlConnections, twBeConnections, removeTwBlConnectionIds_1, _loop_3, _d, twBlConnections_1, twBlConn;
            var _e, _f, _g, _h, _j, _k, _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0: return [4 /*yield*/, this.getLwaClients(useCache)];
                    case 1:
                        clients = _m.sent();
                        connections = [];
                        clientsJustFetched = {};
                        _i = 0, clients_1 = clients;
                        _m.label = 2;
                    case 2:
                        if (!(_i < clients_1.length)) return [3 /*break*/, 12];
                        client = clients_1[_i];
                        platformClient = void 0;
                        if (!((useCache && this.cachedClients[client.clientId])
                            || clientsJustFetched[client.clientId])) return [3 /*break*/, 3];
                        platformClient = this.cachedClients[client.clientId];
                        if (!platformClient) {
                            platformClient = clientsJustFetched[client.clientId];
                            this.cachedClients[client.clientId] = platformClient;
                        }
                        return [3 /*break*/, 7];
                    case 3:
                        if (!token) {
                            token = this.validateAndGetToken();
                        }
                        return [4 /*yield*/, getPlatformClientSummary(client.clientId)];
                    case 4:
                        response = _m.sent();
                        if (!!response.ok) return [3 /*break*/, 5];
                        if (response.status === 401) {
                            if (!isPlatformUiAppId(this.appId)) {
                                this.tryRelaunch();
                                return [2 /*return*/, Promise.resolve([])];
                            }
                            else {
                                return [2 /*return*/, Promise.resolve([])];
                            }
                        }
                        else {
                            return [2 /*return*/, Promise.reject(new Error('Invalid response from platform API'))];
                        }
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, response.json()];
                    case 6:
                        responseJson = _m.sent();
                        platformClient = responseJson;
                        this.cachedClients[client.clientId] = platformClient;
                        clientsJustFetched[client.clientId] = platformClient;
                        _m.label = 7;
                    case 7:
                        _loop_1 = function (application) {
                            var applicationCode, appData, collapseItems, appExist, modules, connection, appName;
                            return __generator(this, function (_o) {
                                switch (_o.label) {
                                    case 0:
                                        applicationCode = application.code;
                                        return [4 /*yield*/, this_1.getAppData()];
                                    case 1:
                                        appData = (_o.sent()).find(function (config) { return config.id === applicationCode; });
                                        collapseItems = (_f = appData === null || appData === void 0 ? void 0 : appData.config.collapseItems) !== null && _f !== void 0 ? _f : false;
                                        appExist = connections.find(function (connection) { return connection.appId === applicationCode; });
                                        modules = (_g = application.modules) === null || _g === void 0 ? void 0 : _g.map(function (module) { return "".concat(application.code, "-").concat(module.code); });
                                        if (collapseItems && appExist)
                                            return [2 /*return*/, "continue"];
                                        connection = {
                                            appId: applicationCode,
                                            name: platformClient.name,
                                            clientId: !collapseItems ? client.clientId : null,
                                            platformClient: true,
                                            modules: modules
                                        };
                                        if (platformClient.branding && (appData === null || appData === void 0 ? void 0 : appData.supportsBranding)) {
                                            connection.branding = {};
                                            if (platformClient.branding.logoUrl) {
                                                connection.branding.logoUrl = platformClient.branding.logoUrl;
                                            }
                                            if (platformClient.branding.applications) {
                                                appName = (_h = platformClient.branding.applications[applicationCode]) === null || _h === void 0 ? void 0 : _h.name;
                                                if (appName && appName !== ((_j = appData === null || appData === void 0 ? void 0 : appData.config) === null || _j === void 0 ? void 0 : _j.name)) {
                                                    connection.branding.appName = appName;
                                                }
                                            }
                                        }
                                        connections.push(connection);
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a = 0, _b = (_e = client.applications) !== null && _e !== void 0 ? _e : [];
                        _m.label = 8;
                    case 8:
                        if (!(_a < _b.length)) return [3 /*break*/, 11];
                        application = _b[_a];
                        return [5 /*yield**/, _loop_1(application)];
                    case 9:
                        _m.sent();
                        _m.label = 10;
                    case 10:
                        _a++;
                        return [3 /*break*/, 8];
                    case 11:
                        _i++;
                        return [3 /*break*/, 2];
                    case 12:
                        twConnections = connections.filter(function (c) { return c.appId === 'tw'; });
                        twNonUserConnections = twConnections.filter(function (conn) {
                            var client = clients.find(function (c) { return c.clientId === conn.clientId; });
                            return (client === null || client === void 0 ? void 0 : client.clientType) !== 'User';
                        });
                        twUserConnection = twConnections.find(function (conn) {
                            var client = clients.find(function (c) { return c.clientId === conn.clientId; });
                            return (client === null || client === void 0 ? void 0 : client.clientType) === 'User';
                        });
                        if (twUserConnection) {
                            userTypeClient = clients
                                .find(function (c) { return c.clientId === twUserConnection.clientId; });
                            userTypeClientExternalSystems_1 = userTypeClient.externalSystems;
                            if (userTypeClientExternalSystems_1
                                && userTypeClientExternalSystems_1.length > 0
                                && twNonUserConnections.length > 0) {
                                removeTwUserConnection = false;
                                _loop_2 = function (twNonUserConnection) {
                                    if (removeTwUserConnection) {
                                        return "break";
                                    }
                                    var client = clients
                                        .filter(function (c) { return c.clientId === twNonUserConnection.clientId; })[0];
                                    var userExternalSystems = client.externalSystems;
                                    var _loop_4 = function (userTypeClientExternalSystem) {
                                        var matchingExternalSystemInfoFound = userExternalSystems
                                            ? userExternalSystems.some(function (ues) {
                                                var _a;
                                                return ues.code === userTypeClientExternalSystem.code
                                                    && ues.number === ((_a = userTypeClientExternalSystems_1.find(function (ex) { return ex.code === userTypeClientExternalSystem.code; })) === null || _a === void 0 ? void 0 : _a.number);
                                            })
                                            : false;
                                        if (matchingExternalSystemInfoFound) {
                                            removeTwUserConnection = true;
                                            return "break";
                                        }
                                    };
                                    for (var _p = 0, userTypeClientExternalSystems_2 = userTypeClientExternalSystems_1; _p < userTypeClientExternalSystems_2.length; _p++) {
                                        var userTypeClientExternalSystem = userTypeClientExternalSystems_2[_p];
                                        var state_2 = _loop_4(userTypeClientExternalSystem);
                                        if (state_2 === "break")
                                            break;
                                    }
                                };
                                for (_c = 0, twNonUserConnections_1 = twNonUserConnections; _c < twNonUserConnections_1.length; _c++) {
                                    twNonUserConnection = twNonUserConnections_1[_c];
                                    state_1 = _loop_2(twNonUserConnection);
                                    if (state_1 === "break")
                                        break;
                                }
                                if (removeTwUserConnection) {
                                    connections = connections.filter(function (conn) { return conn.appId !== 'tw'
                                        || conn.clientId !== twUserConnection.clientId; });
                                }
                            }
                        }
                        getClientType = function (connection) { var _a; return (_a = clients.find(function (client) { return client.clientId === connection.clientId; })) === null || _a === void 0 ? void 0 : _a.clientType; };
                        twBlConnections = connections.filter(function (c) {
                            var _a, _b;
                            var clientType = (_a = getClientType(c)) !== null && _a !== void 0 ? _a : '';
                            return ((_b = c.modules) === null || _b === void 0 ? void 0 : _b.includes('tw-bl')) &&
                                ['MLS', 'Association'].some(function (type) { return clientType.toLowerCase().includes(type.toLowerCase()); });
                        });
                        twBeConnections = connections.filter(function (c) {
                            var _a;
                            return ((_a = c.modules) === null || _a === void 0 ? void 0 : _a.includes('tw-be')) &&
                                getClientType(c) === 'Brokerage';
                        });
                        if (twBlConnections.length > 0 && twBeConnections.length > 0) {
                            removeTwBlConnectionIds_1 = [];
                            _loop_3 = function (twBlConn) {
                                var blExternalSystems = (_k = clients.find(function (c) { return c.clientId === twBlConn.clientId; })) === null || _k === void 0 ? void 0 : _k.externalSystems;
                                if (!(blExternalSystems === null || blExternalSystems === void 0 ? void 0 : blExternalSystems.length))
                                    return "continue";
                                var _loop_5 = function (twBeConn) {
                                    var beExternalSystems = (_l = clients.find(function (c) { return c.clientId === twBeConn.clientId; })) === null || _l === void 0 ? void 0 : _l.externalSystems;
                                    if (!(beExternalSystems === null || beExternalSystems === void 0 ? void 0 : beExternalSystems.length))
                                        return "continue";
                                    var matchingExternalSystemInfoFound = blExternalSystems.some(function (blEs) {
                                        return beExternalSystems.some(function (beEs) {
                                            return beEs.code === blEs.code && beEs.number === blEs.number;
                                        });
                                    });
                                    if (matchingExternalSystemInfoFound) {
                                        removeTwBlConnectionIds_1.push(twBlConn.clientId);
                                        return "break";
                                    }
                                };
                                for (var _q = 0, twBeConnections_1 = twBeConnections; _q < twBeConnections_1.length; _q++) {
                                    var twBeConn = twBeConnections_1[_q];
                                    var state_3 = _loop_5(twBeConn);
                                    if (state_3 === "break")
                                        break;
                                }
                            };
                            for (_d = 0, twBlConnections_1 = twBlConnections; _d < twBlConnections_1.length; _d++) {
                                twBlConn = twBlConnections_1[_d];
                                _loop_3(twBlConn);
                            }
                            if (removeTwBlConnectionIds_1.length > 0) {
                                connections = connections.filter(function (conn) {
                                    var _a;
                                    return !(((_a = conn.modules) === null || _a === void 0 ? void 0 : _a.includes('tw-bl')) &&
                                        removeTwBlConnectionIds_1.includes(conn.clientId));
                                });
                            }
                        }
                        return [2 /*return*/, Promise.resolve(connections)];
                }
            });
        }); };
        return mapClients();
    };
    PlatformService.prototype.getConnections = function (useCache, includePlatformClients) {
        var _this = this;
        var _a, _b;
        if (useCache === void 0) { useCache = true; }
        if (includePlatformClients === void 0) { includePlatformClients = true; }
        var token = this.validateAndGetToken();
        if (!token) {
            return Promise.resolve([]);
        }
        if (useCache && this.cachedConnections !== undefined) {
            return Promise.resolve(includePlatformClients
                ? this.getClientsAsConnections(useCache).then(function (clientsAsConnections) {
                    var _a;
                    return __spreadArray(__spreadArray([], (_a = _this.cachedConnections) !== null && _a !== void 0 ? _a : [], true), clientsAsConnections, true);
                })
                    .catch(function (err) {
                    throw err;
                })
                : __spreadArray([], this.cachedConnections, true));
        }
        var userId = (_b = (_a = Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getUserId();
        return makeFetchCall("".concat(this.getAuthenticationApiUrl(), "/v1/users/").concat(userId, "/connections"), token).then(function (response) {
            if (!response.ok) {
                if (response.status === 401) {
                    if (!isPlatformUiAppId(_this.appId)) {
                        _this.tryRelaunch();
                    }
                    else {
                        return [];
                    }
                }
                else {
                    throw new Error('Invalid response from authentication API');
                }
            }
            else {
                return response.json().then(function (responseJson) {
                    _this.cachedConnections = __spreadArray([], responseJson, true);
                    return includePlatformClients
                        ? _this.getClientsAsConnections(useCache).then(function (clientsAsConnections) {
                            return __spreadArray(__spreadArray([], responseJson, true), clientsAsConnections, true);
                        }).catch(function (err) {
                            throw err;
                        })
                        : responseJson;
                });
            }
        }).catch(function (err) {
            throw err;
        });
    };
    PlatformService.prototype.getAppSections = function (useCache) {
        var _this = this;
        if (useCache === void 0) { useCache = true; }
        return this.getConnections(useCache, true)
            .then(function (connections) { return __awaiter(_this, void 0, void 0, function () {
            var appData, sectionItems, appMap, namesMap, _loop_6, this_2, _i, _a, connection, _b, sectionItems_1, sectionItem;
            var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            return __generator(this, function (_p) {
                switch (_p.label) {
                    case 0: return [4 /*yield*/, this.getAppData(useCache)];
                    case 1:
                        appData = _p.sent();
                        sectionItems = [];
                        appMap = new Map();
                        namesMap = new Map();
                        _loop_6 = function (connection) {
                            var data = void 0;
                            data = appData.find(function (config) { return config.id === connection.appId; });
                            if (!data || data.config.hidden === true)
                                return "continue";
                            var app = void 0;
                            // Create a new SectionItem if one doesn't already exist
                            // OR if there is custom branding
                            if (!appMap.has(connection.appId)
                                || ((_c = connection.branding) === null || _c === void 0 ? void 0 : _c.logoUrl)
                                || ((_d = connection.branding) === null || _d === void 0 ? void 0 : _d.appName)) {
                                app = __assign({ description: data.config.description, label: ((_e = connection.branding) === null || _e === void 0 ? void 0 : _e.appName) || data.config.name, selected: this_2.appId === connection.appId }, (this_2.launchApp(connection)));
                                if ((_f = connection.branding) === null || _f === void 0 ? void 0 : _f.logoUrl) {
                                    app.iconUrl = connection.branding.logoUrl;
                                }
                                else {
                                    app.icon = data.config.icon;
                                }
                                // IF there is no custom branding, push to appMap for future AppInstances to be added to this SectionItem
                                if (!((_g = connection.branding) === null || _g === void 0 ? void 0 : _g.logoUrl) && !((_h = connection.branding) === null || _h === void 0 ? void 0 : _h.appName)) {
                                    appMap.set(connection.appId, app);
                                }
                                sectionItems.push(app);
                            }
                            else {
                                app = appMap.get(connection.appId);
                            }
                            // add the connection name to the list
                            var names = void 0;
                            if (!namesMap.has(connection.appId)
                                || ((_j = connection.branding) === null || _j === void 0 ? void 0 : _j.logoUrl)
                                || ((_k = connection.branding) === null || _k === void 0 ? void 0 : _k.appName)) {
                                names = [__assign({ label: connection.name }, (this_2.launchApp(connection)))];
                                // IF there is no custom branding, push to namesMap for future AppInstances to be added
                                if (!((_l = connection.branding) === null || _l === void 0 ? void 0 : _l.logoUrl) && !((_m = connection.branding) === null || _m === void 0 ? void 0 : _m.appName)) {
                                    namesMap.set(connection.appId, names);
                                }
                            }
                            else {
                                names = namesMap.get(connection.appId);
                                names.push(__assign({ label: connection.name }, (this_2.launchApp(connection))));
                                app.appInstances = names;
                            }
                        };
                        this_2 = this;
                        for (_i = 0, _a = (connections !== null && connections !== void 0 ? connections : []); _i < _a.length; _i++) {
                            connection = _a[_i];
                            _loop_6(connection);
                        }
                        // finally, sort the arrays
                        sectionItems.sort(getCompareFunction('label', { ignoreCase: true }));
                        for (_b = 0, sectionItems_1 = sectionItems; _b < sectionItems_1.length; _b++) {
                            sectionItem = sectionItems_1[_b];
                            (_o = sectionItem.appInstances) === null || _o === void 0 ? void 0 : _o.sort(getCompareFunction('label', { ignoreCase: true }));
                            if (sectionItem.appInstances) {
                                sectionItem.url = sectionItem.appInstances[0].url;
                            }
                        }
                        return [2 /*return*/, [{ sectionItems: sectionItems }]];
                }
            });
        }); });
    };
    PlatformService.prototype.getAdminMenuItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, appId, clients, userPermissions, adminPermissions, adminPermissionsIds, menuItems;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this.validateAndGetToken();
                        appId = this.appId;
                        if (!token) {
                            return [2 /*return*/, Promise.resolve([])];
                        }
                        return [4 /*yield*/, this.getClientsSummary(true)];
                    case 1:
                        clients = _a.sent();
                        return [4 /*yield*/, getJsonResponseFromFetch("".concat(this.getPlatformApiUrl(), "/v1/user-permissions"), token, appId, this.tryRelaunch)];
                    case 2:
                        userPermissions = _a.sent();
                        if (!(userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.length))
                            return [2 /*return*/, []];
                        return [4 /*yield*/, getJsonResponseFromFetch("".concat(this.getPlatformApiUrl(), "/v1/permissions"), token, appId, this.tryRelaunch)];
                    case 3:
                        adminPermissions = _a.sent();
                        adminPermissionsIds = adminPermissions === null || adminPermissions === void 0 ? void 0 : adminPermissions.map(function (p) { return p.id; });
                        menuItems = [];
                        clients === null || clients === void 0 ? void 0 : clients.filter(function (client) { return client.type !== 'User'; }).forEach(function (client) {
                            var _a;
                            var clientPermissions = (_a = userPermissions.find(function (p) { return p.clientId === client.id; })) === null || _a === void 0 ? void 0 : _a.permissions;
                            var hasAdminPermissions = function (permissions) {
                                return adminPermissionsIds.some(function (perm) { return Object.hasOwnProperty.call(permissions, perm); });
                            };
                            if (clientPermissions && hasAdminPermissions(clientPermissions)) {
                                menuItems.push({
                                    label: client.name,
                                    onClick: function () { return _this.redirectAfterPfmAuth("".concat(_this.getPlatformUrl(), "/account/admin/").concat(client.id), true); },
                                });
                                return client;
                            }
                            return undefined;
                        });
                        if (menuItems[0]) {
                            return [2 /*return*/, __spreadArray([
                                    { label: '', url: '', divider: true },
                                    { label: 'Admin', header: true }
                                ], menuItems, true)];
                        }
                        return [2 /*return*/, menuItems];
                }
            });
        });
    };
    ;
    PlatformService.prototype.getUserMenuProps = function (userMenuProps, applicationSignOutUrl) {
        // NOTE: Any changes made here might also require corresponding updates in 'getNavbarUserMenuProps' to maintain consistency.
        var _this = this;
        var _a, _b, _c;
        var menuItems = [];
        var user;
        var token = this.validateAndGetToken();
        if (token) {
            menuItems.push(__assign(__assign({}, (this.enablePopups ? {
                onClick: function () { return _this.redirectAfterPfmAuth(_this.getPlatformUrl() + '/account/manage', true); }
            } : {
                url: this.getPlatformUrl() + '/account/manage'
            })), { label: 'Manage Account' }));
            var jwtPayload = Authentication_1.default.parseToken(token);
            user = {
                name: (jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getFirstName()) + ' ' + (jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getLastName()),
                email: (_a = jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getEmail()) !== null && _a !== void 0 ? _a : '',
                avatarURL: (_b = jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getPicture()) !== null && _b !== void 0 ? _b : ''
            };
        }
        else {
            user = userMenuProps === null || userMenuProps === void 0 ? void 0 : userMenuProps.user;
        }
        if (token || applicationSignOutUrl) {
            var menuItem = {
                label: 'Sign Out'
            };
            if (token) {
                menuItem.onClick = function (ignore) {
                    /* We MUST pass forceLogout as true here because we need to redirect to /logout to ensure that
                    a logout happens. */
                    _this.tryRelaunch(true);
                };
            }
            else {
                menuItem.url = applicationSignOutUrl;
            }
            menuItems.push(menuItem);
        }
        ((_c = userMenuProps === null || userMenuProps === void 0 ? void 0 : userMenuProps.menuItems) !== null && _c !== void 0 ? _c : []).forEach(function (item) {
            menuItems.push(item);
        });
        var signOutElement = menuItems.find(function (element) { return element.label === 'Sign Out'; });
        if (signOutElement) {
            var signOutElementIndex = menuItems === null || menuItems === void 0 ? void 0 : menuItems.indexOf(signOutElement);
            if (signOutElementIndex !== menuItems.length - 1) {
                var divider = {
                    url: '',
                    label: '',
                    divider: true
                };
                menuItems.splice(signOutElementIndex + 1, 0, divider);
            }
        }
        return { menuItems: menuItems, user: user };
    };
    PlatformService.prototype.getNavbarUserMenuProps = function (userMenuProps, applicationSignOutUrl) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var menuItems, user, token, jwtPayload, menuItem, adminMenuItems;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        menuItems = [];
                        token = this.validateAndGetToken();
                        if (token) {
                            menuItems.push(__assign(__assign({}, (this.enablePopups ? {
                                onClick: function () { return _this.redirectAfterPfmAuth(_this.getPlatformUrl() + '/account/manage', true); }
                            } : {
                                url: this.getPlatformUrl() + '/account/manage'
                            })), { label: 'Manage Account' }));
                            if (isPlatformOrFoundationApp(this.appId)) {
                                menuItems.push({
                                    onClick: function () { return _this.redirectAfterPfmAuth(_this.getEcommerceUrl() + '/billing', true); },
                                    label: 'Billing',
                                });
                            }
                            jwtPayload = Authentication_1.default.parseToken(token);
                            user = {
                                name: (jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getFirstName()) + ' ' + (jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getLastName()),
                                email: (_a = jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getEmail()) !== null && _a !== void 0 ? _a : '',
                                avatarURL: (_b = jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getPicture()) !== null && _b !== void 0 ? _b : ''
                            };
                        }
                        else {
                            user = userMenuProps === null || userMenuProps === void 0 ? void 0 : userMenuProps.user;
                        }
                        if (token || applicationSignOutUrl) {
                            menuItem = {
                                label: 'Sign Out'
                            };
                            if (token) {
                                menuItem.onClick = function () {
                                    /* We MUST pass forceLogout as true here because we need to redirect to /logout to ensure that
                                    a logout happens. */
                                    _this.tryRelaunch(true);
                                };
                            }
                            else {
                                menuItem.url = applicationSignOutUrl;
                            }
                            menuItems.push(menuItem);
                        }
                        if (!isPlatformOrFoundationApp(this.appId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getAdminMenuItems()];
                    case 1:
                        adminMenuItems = _d.sent();
                        menuItems.push.apply(menuItems, adminMenuItems);
                        _d.label = 2;
                    case 2:
                        if ((_c = userMenuProps === null || userMenuProps === void 0 ? void 0 : userMenuProps.menuItems) === null || _c === void 0 ? void 0 : _c.length) {
                            menuItems.push.apply(menuItems, __spreadArray([{ url: '', label: '', divider: true }], userMenuProps.menuItems || [], false));
                        }
                        return [2 /*return*/, { menuItems: menuItems, user: user }];
                }
            });
        });
    };
    PlatformService.prototype.validateAndGetToken = function () {
        if (!this.token) {
            this.token = getStoredToken(this.lwDomain, this.appId);
        }
        if ((this.token && isTokenExpired(this.token)) || (!this.token && this.lwaOnly)) {
            if (!isPlatformUiAppId(this.appId)) {
                this.tryRelaunch();
            }
            return undefined;
        }
        return this.token;
    };
    PlatformService.prototype.setToken = function (token) {
        storeToken(this.lwDomain, token, this.appId);
        this.token = token;
    };
    PlatformService.prototype.refreshToken = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.relaunchUponError, relaunchUponError = _c === void 0 ? true : _c;
        if (!isLwolfDomain(this.lwDomain)) {
            return Promise.reject('This function is only supported for applications running on the LW domain.');
        }
        var INTERVAL_MILLIS = 500;
        var TIMEOUT_MILLIS = 20000;
        return new Promise(function (resolve, reject) {
            var timestamp = Date.now();
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.hidden = true;
            iframe.src = "".concat(_this.getPlatformUrl(), "/authenticate");
            document.body.appendChild(iframe);
            var timeout = setTimeout(function () {
                clearResources();
                if (relaunchUponError) {
                    _this.tryRelaunch();
                }
                else {
                    reject('Attempt to refresh token timed out.');
                }
            }, TIMEOUT_MILLIS);
            var checkIFrameStatus = setInterval(function () {
                var _a, _b;
                try {
                    var token = getTokenFromCookie(_this.lwDomain);
                    var tokenIssuedAtTime = (_b = (_a = Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getIssuedAtTime()) !== null && _b !== void 0 ? _b : 0;
                    // IF the token iat claim is recent, we know that it was refreshed and the cookie was updated successfully.
                    if (tokenIssuedAtTime * 1000 > timestamp) {
                        clearResources();
                        _this.token = undefined;
                        resolve(_this.validateAndGetToken());
                    }
                }
                catch (e) {
                    clearResources();
                    if (relaunchUponError) {
                        _this.tryRelaunch();
                    }
                    else {
                        reject(e);
                    }
                }
            }, INTERVAL_MILLIS);
            var clearResources = function () {
                document.body.removeChild(iframe);
                clearInterval(checkIFrameStatus);
                clearTimeout(timeout);
            };
        });
    };
    PlatformService.prototype.getProductName = function () {
        return this.appName;
    };
    PlatformService.prototype.getProductBranding = function (platformClientId, useCache) {
        var _this = this;
        if (useCache === void 0) { useCache = true; }
        var doGetProductBranding = function () { return __awaiter(_this, void 0, void 0, function () {
            var client, token, response, responseJson, productBranding, appName;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(useCache && this.cachedClients[platformClientId])) return [3 /*break*/, 1];
                        client = this.cachedClients[platformClientId];
                        return [3 /*break*/, 5];
                    case 1:
                        token = this.validateAndGetToken();
                        return [4 /*yield*/, makeFetchCall("".concat(this.getPlatformApiUrl(), "/v1/clients/").concat(platformClientId, "/summary"), token)];
                    case 2:
                        response = _c.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        if (response.status === 401) {
                            if (!isPlatformUiAppId(this.appId)) {
                                this.tryRelaunch();
                                return [2 /*return*/, Promise.resolve(undefined)];
                            }
                            else {
                                return [2 /*return*/, Promise.resolve(undefined)];
                            }
                        }
                        else {
                            return [2 /*return*/, Promise.reject(new Error('Invalid response from platform API'))];
                        }
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, response.json()];
                    case 4:
                        responseJson = _c.sent();
                        client = responseJson;
                        this.cachedClients[platformClientId] = client;
                        _c.label = 5;
                    case 5:
                        if (client.branding) {
                            productBranding = {
                                id: client.id
                            };
                            if (client.branding.logoUrl) {
                                productBranding.clientLogoUrl = client.branding.logoUrl;
                            }
                            if (client.branding.applications) {
                                appName = (_b = client.branding.applications[(_a = this.appId) !== null && _a !== void 0 ? _a : '']) === null || _b === void 0 ? void 0 : _b.name;
                                if (appName) {
                                    productBranding.applicationName = appName;
                                }
                            }
                        }
                        return [2 /*return*/, productBranding && Object.keys(productBranding).length > 1
                                ? productBranding
                                : undefined];
                }
            });
        }); };
        return doGetProductBranding();
    };
    PlatformService.prototype.validateSession = function (url, auth) {
        var _this = this;
        var INTERVAL_MILLIS = 1000;
        var TIMEOUT_MILLIS = 3600000;
        var width = 500;
        var height = 500;
        var left = window.screenX + (window.innerWidth - width) / 2;
        var top = window.screenY + (window.innerHeight - height) / 2;
        var authPopup;
        return new Promise(function (resolve, reject) {
            var iframe = document.createElement('iframe');
            iframe.onload = function () {
                authPopup = window.open(auth ? "".concat(_this.getPlatformUrl(), "/auth") : url, 'auth0:authorize:popup', "left=".concat(left, ",top=").concat(top, ",width=").concat(width, ",height=").concat(height, ",resizable,scrollbars=yes,location=0"));
                if (!authPopup) {
                    var authMode = "password";
                    window.location.href = "".concat(url, "&authMode=").concat(authMode);
                }
            };
            var overlay = document.createElement("div");
            overlay.style.cssText = "position: fixed; top: 0; left: 0; width: 100vw; height: 100%; background: rgba(0, 0, 0, 0.1); display: flex; justify-content: center; align-items: center; z-index: 9999";
            document.body.appendChild(overlay);
            document.body.appendChild(iframe);
            var timeout = setTimeout(function () {
                clearResources();
                resolve(false);
            }, TIMEOUT_MILLIS);
            window.addEventListener('message', function (event) {
                if (event.origin === _this.getPlatformUrl()) {
                    if (event.data.type === 'PFM_AUTH_COMPLETED' || event.data.type === 'IDP_APPROVED') {
                        resolve(true);
                        clearResources();
                    }
                }
            });
            var checkPopup = setInterval(function () {
                try {
                    if (!authPopup || authPopup.closed) {
                        clearResources();
                        resolve(false);
                    }
                }
                catch (e) {
                    clearResources();
                    reject(e);
                }
            }, INTERVAL_MILLIS);
            function clearResources() {
                clearInterval(checkPopup);
                clearTimeout(timeout);
                document.body.removeChild(overlay);
                document.body.removeChild(iframe);
                authPopup === null || authPopup === void 0 ? void 0 : authPopup.close();
            }
        });
    };
    PlatformService.prototype.redirectAfterPfmAuth = function (url, auth, connection) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var token, pfmAuth, getUserCanAccess, clientIdToCheck, getSuspendedProduct;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        token = this.tryGetToken();
                        pfmAuth = (_b = (_a = Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getPfmAuth();
                        if (pfmAuth || !token) {
                            window.location.href = url;
                            return [2 /*return*/];
                        }
                        getUserCanAccess = false;
                        if (!connection) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.userCanAccess(connection)];
                    case 1:
                        getUserCanAccess = _d.sent();
                        if (!(!getUserCanAccess && connection.platformClient)) return [3 /*break*/, 3];
                        clientIdToCheck = (_c = connection.clientId) !== null && _c !== void 0 ? _c : undefined;
                        return [4 /*yield*/, this.validateSuspendedProduct(connection.appId, clientIdToCheck)];
                    case 2:
                        getSuspendedProduct = _d.sent();
                        if (getSuspendedProduct && getSuspendedProduct.isSuspendedProduct) {
                            window.location.href = "".concat(this.getPlatformUrl(), "/product/locked?product=").concat(getSuspendedProduct.product);
                            return [2 /*return*/];
                        }
                        _d.label = 3;
                    case 3:
                        if (getUserCanAccess) {
                            window.location.href = url;
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, this.validateSession(url, auth).then(function (res) {
                                if (res) {
                                    window.location.href = url;
                                }
                            })];
                }
            });
        });
    };
    ;
    PlatformService.prototype.userCanAccess = function (connection) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function () {
            var lwtClaim, canAccess, appData, clientIdToCheck_1, appData, idPs;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        lwtClaim = (_a = Authentication_1.default.parseToken(this.validateAndGetToken())) === null || _a === void 0 ? void 0 : _a.getLwtClaim();
                        if (lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.getPfmAuth()) {
                            return [2 /*return*/, true];
                        }
                        canAccess = false;
                        if (!connection.pseudoPromotionalConnection) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getAppData()];
                    case 1:
                        appData = (_b = (_k.sent())) === null || _b === void 0 ? void 0 : _b.find(function (appData) { return appData.id === connection.appId; });
                        canAccess = !!((_c = appData === null || appData === void 0 ? void 0 : appData.config.promotion) === null || _c === void 0 ? void 0 : _c.skipPfmAuth);
                        return [3 /*break*/, 7];
                    case 2:
                        if (!connection.platformClient) return [3 /*break*/, 5];
                        clientIdToCheck_1 = (_d = connection.clientId) !== null && _d !== void 0 ? _d : undefined;
                        if (!!clientIdToCheck_1) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getAppData()];
                    case 3:
                        appData = (_e = (_k.sent())) === null || _e === void 0 ? void 0 : _e.find(function (appData) { return appData.id === connection.appId; });
                        if (((_f = appData === null || appData === void 0 ? void 0 : appData.config) === null || _f === void 0 ? void 0 : _f.collapseItems) || ((_g = appData === null || appData === void 0 ? void 0 : appData.config) === null || _g === void 0 ? void 0 : _g.hidden)) {
                            clientIdToCheck_1 = (_h = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.getPersonalClient()) === null || _h === void 0 ? void 0 : _h.getId();
                        }
                        _k.label = 4;
                    case 4:
                        canAccess = !!((_j = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.getClients()) === null || _j === void 0 ? void 0 : _j.some(function (c) {
                            var _a, _b;
                            return (!clientIdToCheck_1 || c.getId() === clientIdToCheck_1)
                                && ((_b = (_a = c.getApplications()) === null || _a === void 0 ? void 0 : _a.getCodes()) === null || _b === void 0 ? void 0 : _b.some(function (code) { return code === connection.appId; }));
                        }));
                        return [3 /*break*/, 7];
                    case 5:
                        if (!connection.identityProviderId) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.getAuthenticatedIdPs()];
                    case 6:
                        idPs = _k.sent();
                        canAccess = idPs.includes(connection.identityProviderId);
                        _k.label = 7;
                    case 7: return [2 /*return*/, canAccess];
                }
            });
        });
    };
    PlatformService.prototype.canUserAccess = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userCanAccess({
                        appId: args.appId,
                        platformClient: true,
                        clientId: args.clientId
                    })];
            });
        });
    };
    PlatformService.prototype.validateSuspendedProduct = function (appId, activeClientId) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var isSuspendedProduct, appData, lwaClients, client, clientsWithCurrentProduct;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        isSuspendedProduct = false;
                        return [4 /*yield*/, this.getAppData()];
                    case 1:
                        appData = (_a = (_d.sent())) === null || _a === void 0 ? void 0 : _a.find(function (appData) { return appData.id === appId; });
                        return [4 /*yield*/, (this === null || this === void 0 ? void 0 : this.getLwaClients())];
                    case 2:
                        lwaClients = _d.sent();
                        if (activeClientId) {
                            client = lwaClients === null || lwaClients === void 0 ? void 0 : lwaClients.find(function (client) { return client.clientId === activeClientId; });
                            isSuspendedProduct = !!((_b = client === null || client === void 0 ? void 0 : client.applications) === null || _b === void 0 ? void 0 : _b.some(function (app) { return app.code === appData.id && app.statusCode === 'S'; }));
                        }
                        if ((_c = appData === null || appData === void 0 ? void 0 : appData.config) === null || _c === void 0 ? void 0 : _c.collapseItems) {
                            clientsWithCurrentProduct = lwaClients === null || lwaClients === void 0 ? void 0 : lwaClients.filter(function (client) { var _a; return (_a = client.applications) === null || _a === void 0 ? void 0 : _a.some(function (app) { return app.code === (appData === null || appData === void 0 ? void 0 : appData.id); }); });
                            isSuspendedProduct = !!(clientsWithCurrentProduct === null || clientsWithCurrentProduct === void 0 ? void 0 : clientsWithCurrentProduct.every(function (client) { var _a; return (_a = client.applications) === null || _a === void 0 ? void 0 : _a.some(function (app) { return app.code === (appData === null || appData === void 0 ? void 0 : appData.id) && app.statusCode === 'S'; }); }));
                        }
                        return [2 /*return*/, { isSuspendedProduct: isSuspendedProduct, product: appData === null || appData === void 0 ? void 0 : appData.config.name }];
                }
            });
        });
    };
    PlatformService.prototype.launchApp = function (connection) {
        var _this = this;
        var launchUrl = buildProductLaunchUrl(this.getPlatformUrl(), connection, this.appId === connection.appId && this.luParamSupplier
            ? this.luParamSupplier()
            : undefined);
        if (this.enablePopups) {
            return {
                onClick: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.redirectAfterPfmAuth(launchUrl, false, connection)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); }
            };
        }
        else {
            return { url: launchUrl };
        }
    };
    PlatformService.prototype.tryGetToken = function () {
        if (!this.token) {
            this.token = getStoredToken(this.lwDomain, this.appId);
        }
        if (this.token && isTokenExpired(this.token)) {
            return undefined;
        }
        return this.token;
    };
    PlatformService.prototype.getSortedAppIds = function (appData, connections, promotionAppIds) {
        var connectedAppIds = connections.reduce(function (current, next) {
            if (!current.includes(next.appId))
                current.push(next.appId);
            return current;
        }, []);
        // Add static promoted products if no connection exists
        promotionAppIds.forEach(function (id) {
            if (!connectedAppIds.includes(id))
                connectedAppIds.push(id);
        });
        return connectedAppIds.sort(function (a, b) {
            var _a, _b;
            var nameA = ((_a = appData.find(function (app) { return app.id === a; })) === null || _a === void 0 ? void 0 : _a.config.name.toLowerCase()) || '';
            var nameB = ((_b = appData.find(function (app) { return app.id === b; })) === null || _b === void 0 ? void 0 : _b.config.name.toLowerCase()) || '';
            return nameA.localeCompare(nameB);
        });
    };
    PlatformService.prototype.prepareConnectionData = function (getConnections, getAppData, useCache) {
        return __awaiter(this, void 0, void 0, function () {
            var connections, appData, promotionAppIds, productAppIds, filteredConnections, sortedAppIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getConnections(useCache)];
                    case 1:
                        connections = _a.sent();
                        return [4 /*yield*/, getAppData()];
                    case 2:
                        appData = _a.sent();
                        promotionAppIds = appData.filter(function (app) { return app.config.promotion; }).map(function (app) { return app.id; });
                        productAppIds = appData.map(function (app) { return app.id; });
                        filteredConnections = connections.filter(function (conn) { return productAppIds.includes(conn.appId); });
                        sortedAppIds = this.getSortedAppIds(appData, filteredConnections, promotionAppIds);
                        return [2 /*return*/, {
                                appData: appData,
                                filteredConnections: filteredConnections,
                                promotionAppIds: promotionAppIds,
                                sortedAppIds: sortedAppIds,
                            }];
                }
            });
        });
    };
    PlatformService.prototype.getGroupedAppConnections = function (useCache) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, promotionAppIds, filteredConnections, sortedAppIds, mappedAppConnections, _loop_7, _i, sortedAppIds_1, appId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.prepareConnectionData(this.getConnections.bind(this), this.getAppData.bind(this), useCache)];
                    case 1:
                        _a = _b.sent(), promotionAppIds = _a.promotionAppIds, filteredConnections = _a.filteredConnections, sortedAppIds = _a.sortedAppIds;
                        mappedAppConnections = [];
                        _loop_7 = function (appId) {
                            var group = filteredConnections.filter(function (conn) { return conn.appId === appId; });
                            group.sort(function (a, b) { var _a; return ((_a = a.name) === null || _a === void 0 ? void 0 : _a.localeCompare(b.name || '')) || 0; });
                            if (group.length) {
                                mappedAppConnections.push(group);
                            }
                            else if (promotionAppIds.includes(appId)) {
                                mappedAppConnections.push([{ appId: appId, name: '', pseudoPromotionalConnection: true }]);
                            }
                        };
                        for (_i = 0, sortedAppIds_1 = sortedAppIds; _i < sortedAppIds_1.length; _i++) {
                            appId = sortedAppIds_1[_i];
                            _loop_7(appId);
                        }
                        return [2 /*return*/, mappedAppConnections];
                }
            });
        });
    };
    PlatformService.prototype.getConnectionTiles = function (useCache) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __awaiter(this, void 0, void 0, function () {
            var _m, appData, promotionAppIds, filteredConnections, sortedAppIds, mappedAppConnections, _loop_8, this_3, _i, sortedAppIds_2, appId;
            var _this = this;
            return __generator(this, function (_o) {
                switch (_o.label) {
                    case 0: return [4 /*yield*/, this.prepareConnectionData(this.getConnections.bind(this), this.getAppData.bind(this), useCache)];
                    case 1:
                        _m = _o.sent(), appData = _m.appData, promotionAppIds = _m.promotionAppIds, filteredConnections = _m.filteredConnections, sortedAppIds = _m.sortedAppIds;
                        mappedAppConnections = [];
                        _loop_8 = function (appId) {
                            var app = appData.find(function (a) { return a.id === appId; });
                            var brandingConnections = [];
                            var unbrandedConnections = [];
                            if (app === null || app === void 0 ? void 0 : app.config.hidden)
                                return "continue";
                            var group = filteredConnections.filter(function (conn) { return conn.appId === appId; });
                            var unbrandedOptions = [];
                            var baseTileData = {
                                appId: appId,
                                appName: (_a = app === null || app === void 0 ? void 0 : app.config.name) !== null && _a !== void 0 ? _a : '',
                                description: (_b = app === null || app === void 0 ? void 0 : app.config.description) !== null && _b !== void 0 ? _b : '',
                                icon: app === null || app === void 0 ? void 0 : app.config.icon,
                            };
                            var _loop_9 = function (conn) {
                                var launchUrl = buildProductLaunchUrl(this_3.getPlatformUrl(), conn, this_3.appId === conn.appId && this_3.luParamSupplier ? this_3.luParamSupplier() : undefined);
                                var tile = __assign({ appId: conn.appId, appName: (_e = (_d = (_c = conn.branding) === null || _c === void 0 ? void 0 : _c.appName) !== null && _d !== void 0 ? _d : app === null || app === void 0 ? void 0 : app.config.name) !== null && _e !== void 0 ? _e : '', description: (_f = app === null || app === void 0 ? void 0 : app.config.description) !== null && _f !== void 0 ? _f : '' }, (((_g = conn.branding) === null || _g === void 0 ? void 0 : _g.logoUrl) ? { logoUrl: conn.branding.logoUrl } : { icon: app === null || app === void 0 ? void 0 : app.config.icon }));
                                var option = {
                                    name: conn.name,
                                    onClick: function () { return _this.redirectAfterPfmAuth(launchUrl, false, conn); }
                                };
                                if (((_h = conn.branding) === null || _h === void 0 ? void 0 : _h.appName) || ((_j = conn.branding) === null || _j === void 0 ? void 0 : _j.logoUrl)) {
                                    brandingConnections.push(__assign(__assign({}, tile), { options: [option] }));
                                }
                                else {
                                    unbrandedOptions.push(option);
                                    baseTileData = __assign({}, tile);
                                }
                            };
                            for (var _p = 0, group_1 = group; _p < group_1.length; _p++) {
                                var conn = group_1[_p];
                                _loop_9(conn);
                            }
                            if (unbrandedOptions.length) {
                                unbrandedConnections.push(__assign(__assign({}, baseTileData), { options: unbrandedOptions.sort(function (a, b) {
                                        return 0 - ((a === null || a === void 0 ? void 0 : a.name) && (b === null || b === void 0 ? void 0 : b.name) && (a === null || a === void 0 ? void 0 : a.name.toLowerCase()) > (b === null || b === void 0 ? void 0 : b.name.toLowerCase()) ? -1 : 1);
                                    }) }));
                            }
                            if (unbrandedConnections.length) {
                                mappedAppConnections.push(unbrandedConnections);
                            }
                            if (brandingConnections.length) {
                                mappedAppConnections.push(brandingConnections);
                            }
                            if (!group.length && promotionAppIds.includes(appId)) {
                                var conn_1 = {
                                    appId: appId,
                                    name: '',
                                    pseudoPromotionalConnection: true
                                };
                                var launchUrl_1 = buildProductLaunchUrl(this_3.getPlatformUrl(), conn_1, this_3.appId === conn_1.appId && this_3.luParamSupplier ? this_3.luParamSupplier() : undefined);
                                mappedAppConnections.push([{
                                        appId: appId,
                                        appName: (_k = app === null || app === void 0 ? void 0 : app.config.name) !== null && _k !== void 0 ? _k : '',
                                        description: (_l = app === null || app === void 0 ? void 0 : app.config.description) !== null && _l !== void 0 ? _l : '',
                                        icon: app === null || app === void 0 ? void 0 : app.config.icon,
                                        options: [{ name: conn_1.name, onClick: function () { return _this.redirectAfterPfmAuth(launchUrl_1, false, conn_1); } }],
                                    }]);
                            }
                        };
                        this_3 = this;
                        for (_i = 0, sortedAppIds_2 = sortedAppIds; _i < sortedAppIds_2.length; _i++) {
                            appId = sortedAppIds_2[_i];
                            _loop_8(appId);
                        }
                        return [2 /*return*/, mappedAppConnections.flat()];
                }
            });
        });
    };
    return PlatformService;
}());
exports.default = PlatformService;
